import React from 'react'
import FrontPageReviewCard, { FrontPageReviewItem } from './FrontPageReviewCard'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'

const reviews: Array<FrontPageReviewItem> = [
  {
    content: 'They provided us with an exceptional value package for a stay at Avani+ resort in Khao Lak, Thailand. We were very well taken care of by the staff who recognised the booking from LE as important and even had a specially curated menu for LE guests.',
    name: 'Rawna',
    region: 'Singapore',
    source: 'trustpilot',
  },
  {
    content: 'This is our second trip with Luxury Escape. The first time was to Maldives a year ago. The coming tour is 12 days to Sri Lanka in 2025. We are very pleased to work with Luxury Escape from day 1. They are very responsive and helpful. They are in Australia and we are in Singapore...',
    name: 'Aston C.',
    source: 'trustpilot',
  },
  {
    content: 'This escape was planned from beginning to end. The Intercontinental Hotel in Singapore was excellent. We felt special from the minute they opened our car door for us. The inclusions were excellent.',
    name: 'Patricia A',
    source: 'trustpilot',
  },
  {
    content: 'Yet again another great holiday booking via Luxury Escapes. A personal thank you to Tammie R for sorting out our bookings to accommodate the kids and family. It truly took the stress out of booking and making changes to get it right. She was patient and kind. She actioned our requests promptly and followed up to keep us updated on what was going on in real time. A genuine thank you from us.',
    name: 'A Nazareth',
    source: 'trustpilot',
  },
  {
    content: 'I have booked 2 trips with Luxury Escapes. The first was so amazing that we had to book again! I needed to get some additional information and called. Emily H. was so helpful. She gave me the different options and followed up. I highly recommend booking your next vacation with Luxury Escapes.',
    name: 'Stracy A.',
    source: 'google',
  },
]

function FrontPageReviews() {
  return (
    <CardCarousel snap="start" gap={32}>
      {reviews.map((review, index) => (
        <FrontPageReviewCard key={index} {...review} />
      ))}
    </CardCarousel>
  )
}

export default FrontPageReviews
